import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'Section/KeyValue', method: 'GET', body: null, token: token })
}
